import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationScanDeleteArgs,
  QuerySearchScansArgs,
  QuerySearchScansSuggestionsArgs,
  Scan,
  ScanConnection,
  SearchScansOutput,
  SearchSuggestionsOutput,
} from "types/generated";

import { ScansListItem } from "../types";

type SearchScansData = {
  searchScans: {
    edges: Array<Pick<ScanConnection, "cursor"> & { node: ScansListItem }>;
    pageInfo: SearchScansOutput["pageInfo"];
  };
};

export const SEARCH_SCANS: TypedDocumentNode<SearchScansData, QuerySearchScansArgs> = gql`
  query SearchScans($input: SearchInput!) {
    searchScans(input: $input) {
      edges {
        cursor
        node {
          id
          name
          labels
          space {
            id
          }
          providerConfigs {
            type
          }
          latestRun {
            state
            stateChangedAt
            resourceStats {
              unmanaged
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;

type SearchScansCountData = {
  searchScansSuggestions: {
    filteredCount: SearchSuggestionsOutput["filteredCount"];
  };
};

export const SEARCH_SCANS_COUNT: TypedDocumentNode<
  SearchScansCountData,
  QuerySearchScansSuggestionsArgs
> = gql`
  query SearchScansCount($input: SearchSuggestionsInput!) {
    searchScansSuggestions(input: $input) {
      filteredCount
    }
  }
`;

type ScanDeleteData = {
  scanDelete: Pick<Scan, "id"> | null;
};

export const SCAN_DELETE: TypedDocumentNode<ScanDeleteData, MutationScanDeleteArgs> = gql`
  mutation ScanDelete($id: ID!) {
    scanDelete(id: $id) {
      id
    }
  }
`;
